import { Component ,EventEmitter,Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-gallery-navcard',
  imports: [CommonModule, RouterLink],
  standalone: true,
  templateUrl: './gallery-navcard.component.html',
  styleUrl: './gallery-navcard.component.scss'
})
export class GalleryNavcardComponent {
@Output() close = new EventEmitter<void>();

constructor(private router: Router) {}

  closeCard() {
    this.close.emit();
  }

    navigateTo(path: string) {
    this.close.emit(); 
    this.router.navigate([`/${path}`]);
  }
}
